@if (!hideMenuTriggerButton()) {
  <button
    mat-icon-button
    [matMenuTriggerFor]="relatedSearchesMenu"
    [matTooltip]="'RELATED_SEARCHES' | transloco"
    matTooltipShowDelay="1000"
    matTooltipPosition="below"
  >
    <mat-icon>plagiarism</mat-icon>
  </button>
}
<mat-menu #relatedSearchesMenu="matMenu">
  @for (search of searches$ | async; track search) {
    <button mat-menu-item (click)="onClickSearch($event, search)">
      {{ search.name }}
    </button>
  }
</mat-menu>
